export const media = state => state.getIn(['supplementalMedia', 'media'])
export const mediaStopId = state => state.getIn(['supplementalMedia', 'stopid'])
export const supplementalMediaInfoVisible = state => state.getIn(['supplementalMedia', 'infoVisible'])
export const supplementalMediaPreviewVisible = state => state.getIn(['supplementalMedia', 'previewVisible'])
export const supplementalMediaShowAll = state => state.getIn(['supplementalMedia', 'showAllMedia'])
export const supplementalMediaTab = state => state.getIn(['supplementalMedia', 'tab'])
export const supplementalMediaVisible = state => state.getIn(['supplementalMedia', 'visible'])
